import React, { useContext } from "react";
import { FaCheckDouble, FaWrench, FaWeightHanging, FaHardHat } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import '../Audit/AuditGlobal.css';
import BannerImage from '../../assets/core_services/lifting_tools_hero_1776820137641.png';

function LiftingTools() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/lifting-tools');
    } else {
      navigate('/login', { state: { from: '/booking/lifting-tools' } });
    }
  };

  return (
    <div className="audit-page">
      <div className="audit-max-width">

        {/* --- HERO --- */}
        <div className="audit-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Core Services</span>
          <h1 className="hero-title">Lifting Tools & Tackles Calibration</h1>
          <p className="hero-subtitle">
            Load testing, inspection, and certification of lifting equipment to ensure safe load handling and regulatory compliance.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Enquire Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Safety Under Tension</h2>
              <p className="article-text">
                Equipment used for lifting or suspending loads operates under extreme stress. Regular inspection and calibration of Lifting Tools and Tackles (LTT) are critical to prevent catastrophic failures, ensuring the safety of personnel and the protection of valuable assets.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Rigorous Certification Process</h2>
              <p className="article-text">
                Our certification covers all types of LTT, including cranes, hoists, slings, shackles, and chain blocks. The process involves:
                <br />- <strong>Visual Examination:</strong> Identifying wear, corrosion, and deformation.
                <br />- <strong>Proof Load Testing:</strong> Subjecting the equipment to controlled loads exceeding their Safe Working Load (SWL).
                <br />- <strong>Non-Destructive Testing (NDT):</strong> Checking for internal flaws in critical components.
                <br />- <strong>Certification:</strong> Issuance of formal certificates valid under factory acts and global standards.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Compliance and Confidence</h2>
              <p className="article-text">
                Testing and calibrating your lifting equipment provides legal compliance, prevents downtime due to equipment failure, and most importantly, saves lives.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Key Checks</h4>
              <ul className="key-list">
                <li><FaWeightHanging className="check-icon" /> Load Verification</li>
                <li><FaWrench className="check-icon" /> Asset Calibration</li>
                <li><FaHardHat className="check-icon" /> Operator Safety</li>
                <li><FaCheckDouble className="check-icon" /> Test Certificates</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Secure Your Lifts</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Schedule your mandatory lifting tools inspection today.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Schedule Testing
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default LiftingTools;
